import Inputmask from "inputmask";
export default function () {
    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    Inputmask('999-999-9999').mask($('#phone'));
    Inputmask(emailPattern).mask($('#email'));

    function validate($el) {
        if ($.trim($el.val()) === '') {
            $el.addClass('is-invalid');
        } else {
            $el.removeClass('is-invalid');
        }
    }

    $('#first, #last, #event_address, #city, #zip, #date, #start_time, #how_long, #email, #phone').blur(function (e) {
        validate($(this));
    });

    // Form Validation using jQuery
    $('#eventForm').submit(function (event) {
        event.preventDefault();

        let $form = $(this);
        let $submitButton = $('#submitButton');
        let $spinner = $('#spinner');

        // Manually trigger validation for all fields
        $('#first, #last, #event_address, #city, #zip, #date, #start_time, #how_long, #email, #phone').each(function() {
            validate($(this));
        });

        // Check if the form has invalid fields
        if ($form.find('.is-invalid').length > 0) {
            return; // Stop here if there are validation errors
        }

        $submitButton.hide(); // Disable the submit button
        $spinner.show(); // Show the spinner

         $form.off('submit').submit();
    });
}
